/**
 * Main JavaScript file for the WordPres theme
 *
 * This file gets loaded for all users.
 *
 * @license        No license
 * (Without a license, the code is copyrighted by default.
 * People can read the code, but they have no legal right to use
 * it. To use the code, you must contact the author directly and
 * ask permission.)
 *
 * @author        Stimmt Digital B.V.
 * @link        https://stimmt.digital
 * @email        support@stimmt.digital
 *
 * @file        app.js
 *
 * @copyright    (C) 2021, Stimmt Digital B.V.
 */

(function ($) {
    $(document).ready(function ($) {
        $('.legend').on('click', function (event) {
            $('.c-modal-wrapper').addClass('show-tooltips');
            $('html').addClass('hidden');
        });

        $('.c-modal__overlay, .c-modal__close').on('click', function (event) {
            $('.c-modal-wrapper').removeClass('show-tooltips');
            $('html').removeClass('hidden');
        });

        $('.locator-button').on('click touch', function (e) {
            if ($(e.currentTarget).data('location')) {
                $('.locator-query').val($(e.currentTarget).data('location'));
                $('#store-locator-form').submit();
            }
        });

        if ($('.fabric-slider').length) {
            $('.fabric-slider').slick({
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                fade: true,
                asNavFor: '.fabric-slider-nav'
            });
        }

        if ($('.fabric-slider-nav').length) {
            $('.fabric-slider-nav').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.fabric-slider',
                centerMode: true,
                focusOnSelect: true
            });
        }

        if ($('backdrop__img-slider').length) {
            $('.backdrop__img-slider').slick({
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true
            });
        }

        if ($('customer-reviews').length) {
            $('.customer-reviews').slick({
                autoplay: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                fade: true
            });
        }

        $('.notice-bar p').click(function () {
            $('.newsletter-wrapper').toggleClass('active');
        });

        $('.close').click(function () {
            $('.active').removeClass('active');
        });

        // Slick slider
        if ($.fn.slick) {

            let $backdrop = $('.backdrop');
            if ($backdrop.find('.backdrop__item').length > 1) {
                $backdrop.slick({
                    dots: ($(this).find('.backdrop__item').length > 1), // Ternary to hide the dots when there's only 1 item
                    fade: true,
                    slide: '.backdrop__item',
                    autoplay: true,
                    autoplaySpeed: 5000,
                    pauseOnHover: false

                    // Check next slide class on beforeChange for dots color

                }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    let $slickDots = $('.slick-dots');
                    if ($(this).find('.backdrop__item').eq(nextSlide).hasClass('backdrop__item--light')) {
                        $slickDots.addClass('slick-dots--light');
                    } else {
                        $slickDots.removeClass('slick-dots--light');
                    }
                });
            }

            // Accessoires @ boxspring modellen

            $('.accessories__gallery--slider').slick({
                arrows: false,
                dots: true,
                infinite: false
            });

            // Historie @ Over Pullman

            $('.history').slick({
                centerMode: false,
                arrows: false,
                dots: true,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 6000,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1
                        }
                    }
                ]
            });

        }

        // Fabrics selection
        let $fabrics = $('.fabrics');
        $fabrics.find('input').on('change', function () {
            let fabricImage = $(this).prev('img').attr('data-bg-src');
            let fabricDominantColor = $(this).attr('data-dominant-color');
            let fabricName = $(this).attr('value');

            $fabrics.addClass('is-loading');

            // Create an img element to check src load

            $('<img/>').attr('src', '' + fabricImage + '').on('load', function () {

                $(this).remove(); // prevent memory leaks

                setTimeout(function () {

                    // Set gradient colors based on dominants rbg's

                    $fabrics.css({background: "linear-gradient(to right, rgba(" + fabricDominantColor + ",1) 0%,rgba(" + fabricDominantColor + ",0) 100%), linear-gradient(to left, rgba(" + fabricDominantColor + ",1) 0%,rgba(" + fabricDominantColor + ",0) 25%)"});
                    $fabrics.find('.fabrics__background-image').css({backgroundImage: "linear-gradient(to top, rgb(" + fabricDominantColor + ") 5%, rgba(" + fabricDominantColor + ", 0) 100%), url(" + fabricImage + ")"});

                    $fabrics.find('.fabrics__background-image').css({backgroundImage: "url(" + fabricImage + ")"});
                    $fabrics.find('.fabrics__title').replaceWith('<h3 class=\"fabrics__title\">' + fabricName + '</h3>');
                    $fabrics.removeClass('is-loading');

                }, 200);

            });
        });

        $('#side-panel').on('click', function (e) {
            e.preventDefault();
            $('.side-panel').toggleClass('open');
        });

        $('.side-panel__close').on('click', function (e) {
            $('.side-panel').toggleClass('open');
        });

        if ($('.map-wrapper').length > 0) {
            let distance = $('.map-wrapper').offset().top,
                $window = $(window);

            $window.scroll(function () {
                if ($window.scrollTop() >= distance) {
                    $('.top-bar').addClass('visible');
                } else {
                    $('.top-bar').removeClass('visible');
                }
            });
        }

        // Scroll to element
        $('[data-scroll-to]').on('click', function (e) {
            e.preventDefault();
            let el = $(this).data('scroll-to');
            let elOffset = $('' + el + '').offset().top;
            let headerHeight = $('.page-header').prop('scrollHeight');

            $('html, body').animate({scrollTop: elOffset - headerHeight + 'px'}, 300);
        });

        // Mobile nav toggle
        if ($(window).width() <= 768) {
            $('.nav--page-header .menu-item-has-children').on('click', function (e) {
                e.stopImmediatePropagation();
                let $current_sub = $(this).find('> .sub-menu');
                if (!$current_sub.is(':visible')) {
                    e.preventDefault();
                }
                $(this).find('> a').addClass('is-clickable');
                $current_sub.stop().slideDown(300);
            });
        }

        /**
         * Prevent body scrolling on mobile devices while the navigation is opened
         */
        if ($('nav--page-header').length) {
            (function () {
                let _overlay = document.getElementsByClassName('nav--page-header')[0];
                let _clientY = null;

                _overlay.addEventListener('touchstart', function (event) {
                    if (event.targetTouches.length === 1) {
                        _clientY = event.targetTouches[0].clientY;
                    }
                }, false);

                _overlay.addEventListener('touchmove', function (event) {
                    if (event.targetTouches.length === 1) {
                        disableRubberBand(event);
                    }
                }, false);

                function disableRubberBand(event) {
                    let clientY = event.targetTouches[0].clientY - _clientY;

                    if (_overlay.scrollTop === 0 && clientY > 0) {
                        event.preventDefault();
                    }

                    if (isOverlayTotallyScrolled() && clientY < 0) {
                        event.preventDefault();
                    }
                }

                function isOverlayTotallyScrolled() {
                    return _overlay.scrollHeight - _overlay.scrollTop <= _overlay.clientHeight;
                }
            });
        }
        ;

        if (Cookies.get('wintercampaign__modal') !== 'true') {

            if (!$('body').hasClass('page-id-5223') || !($('body').hasClass('page-id-4554'))) {
                $("#wintercampaign__modal").addClass('modal--active');
            }

            // Prevent events from getting pass .popup
            $(".modal__inner").on('click', function (e) {
                e.stopPropagation();
            });

            // Set cookie for modal
            $('.close_modal').on('click', function () {
                $('#wintercampaign__modal').removeClass('modal--active');
                Cookies.set('wintercampaign__modal', 'true', {expires: 7});
            });

            // Set cookie when navigating away or reloading
            window.onbeforeunload = function() {
                if ($('#wintercampaign__modal').hasClass('modal--active')) {
                    Cookies.set('wintercampaign__modal', 'true', { expires: 7 });
                }
            };
        }


        /**
         * Check if gravity form is active
         * on current page and add class
         */
        if ($('.remove-header-top').length) {
            let gravityForm = $('.remove-header-top')[0];
            if (gravityForm.length > 1 && $(window).width() < 1023) {
                let body = $('body')[0];
                body.classList.add('gravity-form-exists');
            }
        }

    });

    $(document).on('click', '.newsletter-btn, .overlay.active', function (evt) {
        evt.stopImmediatePropagation();
        let popout = $('.newsletter-popout');
        let overlay = $('.overlay');
        popout.toggleClass('active');
        overlay.toggleClass('active');
    });
})(jQuery);

document.addEventListener('DOMContentLoaded', function() {
    const dealerLabel = document.querySelector('.header__dealer-label');
    let lastScrollTop = 0;

    if(dealerLabel) {
        window.addEventListener('scroll', function() {
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > lastScrollTop) {
                // Scrolling down
                dealerLabel.classList.add('hidden');
            } else {
                // Scrolling up
                dealerLabel.classList.remove('hidden');
            }
            lastScrollTop = scrollTop;
        });
    }
});
